var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomScaleRating = function SvgCustomScaleRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185 116"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58093",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58078"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff6e6e",
    d: "M0 0h33v28H0z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e25959",
    d: "M23 0h10v28H23z",
    "data-name": "Rectangle 33331"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58079"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa6f",
    d: "M38 0h33v28H38z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec985f",
    d: "M61 0h10v28H61z",
    "data-name": "Rectangle 33331"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58080"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe470",
    d: "M76 0h33v28H76z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eccf52",
    d: "M99 0h10v28H99z",
    "data-name": "Rectangle 33331"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58081"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e3ff71",
    d: "M114 0h33v28h-33z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cee254",
    d: "M137 0h10v28h-10z",
    "data-name": "Rectangle 33331"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58082"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a7ff6b",
    d: "M152 0h33v28h-33z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88d84a",
    d: "M175 0h10v28h-10z",
    "data-name": "Rectangle 33331"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58083"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff6e6e",
    d: "M0 44h33v28H0z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e25959",
    d: "M23 44h10v28H23z",
    "data-name": "Rectangle 33331"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58084"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa6f",
    d: "M38 44h33v28H38z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec985f",
    d: "M61 44h10v28H61z",
    "data-name": "Rectangle 33331"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58085"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe470",
    d: "M76 44h33v28H76z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eccf52",
    d: "M99 44h10v28H99z",
    "data-name": "Rectangle 33331"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58086"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e3ff71",
    d: "M114 44h33v28h-33z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cee254",
    d: "M137 44h10v28h-10z",
    "data-name": "Rectangle 33331"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58087"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a7ff6b",
    d: "M152 44h33v28h-33z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88d84a",
    d: "M175 44h10v28h-10z",
    "data-name": "Rectangle 33331"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58088"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff6e6e",
    d: "M0 88h33v28H0z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e25959",
    d: "M23 88h10v28H23z",
    "data-name": "Rectangle 33331"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58089"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa6f",
    d: "M38 88h33v28H38z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec985f",
    d: "M61 88h10v28H61z",
    "data-name": "Rectangle 33331"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58090"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe470",
    d: "M76 88h33v28H76z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eccf52",
    d: "M99 88h10v28H99z",
    "data-name": "Rectangle 33331"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58091"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e3ff71",
    d: "M114 88h33v28h-33z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cee254",
    d: "M137 88h10v28h-10z",
    "data-name": "Rectangle 33331"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58092"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a7ff6b",
    d: "M152 88h33v28h-33z",
    "data-name": "Rectangle 33330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88d84a",
    d: "M175 88h10v28h-10z",
    "data-name": "Rectangle 33331"
  })))));
};
export default SvgCustomScaleRating;